module.exports = __webpack_public_path__ + "static/media/icon-expand.c439f11b.svg";